import { ChangeEvent, FC, ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form';
import { Input, InputProps } from '../ui/input';
import { cn } from '@/lib/utils';

interface IShadCnFormInputProps extends InputProps {
  name: string;
  placeholder?: string;
  disabled?: boolean;
  label?: ReactNode;
  required?: boolean;
  inputClassName?: string;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
}

const ShadCnFormInput: FC<IShadCnFormInputProps> = ({
  name,
  placeholder = '',
  disabled = false,
  label = '',
  required = false,
  className,
  inputClassName,
  onChange,
  ...rest
}) => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn('w-full', className)}>
          {!!label && (
            <FormLabel>
              {label} {required && <span className='text-red-500'>*</span>}
            </FormLabel>
          )}
          <FormControl>
            <Input
              {...field}
              {...rest}
              value={field.value ?? (rest.type === 'number' ? '' : '')}
              className={inputClassName}
              onFocus={(e) => {
                if (rest.type === 'number') e.target.select();
                rest.onFocus?.(e);
              }}
              onChange={(e) => {
                if (rest.type === 'number' && e.target.value !== '') {
                  field.onChange(Number(e.target.value));
                } else field.onChange(e);
                onChange?.(e);
              }}
              placeholder={placeholder}
              disabled={disabled}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ShadCnFormInput;
